import { controls,grouped } from "../controls";
const slbc_investment_credit_outstandings = {
label: "Slbc Investment Credit Outstandings",
pageLabel: "Slbc Investment Credit Outstandings",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Slbc Block",star:true}),
...controls.oc({ tab: "general", c: "SLBCBlock", placeHolder: "Slbc Block Code", name: "slbc_block_code",isRequired:true,fastpath: "slbc_blocks",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "slbc_block_display"}),
...controls.displayText({ tab: "general", label: "KCCs for animal husbandry and allied activities AC  at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "kccs_animal_husb_allied_activities_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "KCCs for animal husbandry and allied activities Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "kccs_animal_husb_allied_activities_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Farm Production organistaion AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "farm_production_org_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Farm Production organistaion Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "farm_production_org_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Dairy Dev AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "dairy_dev_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Dairy Dev Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "dairy_dev_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Farm Mechanisation Ac at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "farm_mechanisation_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Farm Mechanisation Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "farm_mechanisation_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Poultry AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "poultry_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Poultry Amt at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "poultry_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Fisheries AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "fisheries_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Fisheries Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "fisheries_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Rural Godown AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "rural_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Rural Godown Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "rural_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Clinic AC at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "agri_clinic_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Agri Clinic Amt at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "agri_clinic_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Ac at the end of Current Quarter",star:true}),
...controls.text({ tab: "general",  placeHolder: "", name: "other_ac",isRequired:true,maxlength:20}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Other Amount at the end of Current Quarter"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "other_amt",maxlength:18}),
...controls.displayText({ tab: "general", label: ""}),
]
,history:{
perPage: 10,
reportHeader: "Slbc Investment Credit Outstandings",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "KCCs for animal husbandry and allied activities AC  at the end of Current Quarter",accessor: "kccs_animal_husb_allied_activities_ac",},
{Header: "KCCs for animal husbandry and allied activities Amount at the end of Current Quarter",accessor: "kccs_animal_husb_allied_activities_amt",},
{Header: "Farm Production organistaion AC at the end of Current Quarter",accessor: "farm_production_org_ac",},
{Header: "Farm Production organistaion Amount at the end of Current Quarter",accessor: "farm_production_org_amt",},
{Header: "Dairy Dev AC at the end of Current Quarter",accessor: "dairy_dev_ac",},
{Header: "Dairy Dev Amount at the end of Current Quarter",accessor: "dairy_dev_amt",},
{Header: "Farm Mechanisation Ac at the end of Current Quarter",accessor: "farm_mechanisation_ac",},
{Header: "Farm Mechanisation Amount at the end of Current Quarter",accessor: "farm_mechanisation_amt",},
{Header: "Poultry AC at the end of Current Quarter",accessor: "poultry_ac",},
{Header: "Poultry Amt at the end of Current Quarter",accessor: "poultry_amt",},
{Header: "Fisheries AC at the end of Current Quarter",accessor: "fisheries_ac",},
{Header: "Fisheries Amount at the end of Current Quarter",accessor: "fisheries_amt",},
{Header: "Rural Godown AC at the end of Current Quarter",accessor: "rural_ac",},
{Header: "Rural Godown Amount at the end of Current Quarter",accessor: "rural_amt",},
{Header: "Agri Clinic AC at the end of Current Quarter",accessor: "agri_clinic_ac",},
{Header: "Agri Clinic Amt at the end of Current Quarter",accessor: "agri_clinic_amt",},
{Header: "Other Ac at the end of Current Quarter",accessor: "other_ac",},
{Header: "Other Amount at the end of Current Quarter",accessor: "other_amt",},
]}};
export default slbc_investment_credit_outstandings;